type UploadIconProps = {
  className?: string;
};

export const UploadIcon = ({ className = "" }: UploadIconProps) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`h-8 w-8 md:h-16 md:w-16 ${className}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9979 19.0481C16.1685 11.1418 23.4037 5.33331 32 5.33331C40.5963 5.33331 47.8315 11.1418 50.0021 19.0481C56.4963 20.5589 61.3333 26.38 61.3333 33.3333C61.3333 38.421 58.7406 42.902 54.8167 45.5286C53.5928 46.3478 51.9366 46.0198 51.1173 44.7959C50.2981 43.5721 50.6261 41.9158 51.85 41.0966C54.358 39.4177 56 36.5668 56 33.3333C56 28.4741 52.2846 24.4795 47.5414 24.0403C46.3332 23.9284 45.3528 23.0149 45.156 21.8175C44.1162 15.4924 38.6191 10.6666 32 10.6666C25.3809 10.6666 19.8838 15.4924 18.844 21.8175C18.6472 23.0149 17.6668 23.9284 16.4586 24.0403C11.7154 24.4795 8 28.4741 8 33.3333C8 36.5668 9.64201 39.4177 12.15 41.0966C13.3739 41.9158 13.7019 43.5721 12.8827 44.7959C12.0635 46.0198 10.4072 46.3478 9.18331 45.5286C5.25941 42.902 2.66667 38.421 2.66667 33.3333C2.66667 26.38 7.50374 20.5589 13.9979 19.0481ZM29.3333 38.4379L23.219 44.5523C22.1776 45.5937 20.4891 45.5937 19.4477 44.5523C18.4063 43.5109 18.4063 41.8224 19.4477 40.781L30.1144 30.1144C31.1558 29.073 32.8442 29.073 33.8856 30.1144L44.5523 40.781C45.5937 41.8224 45.5937 43.5109 44.5523 44.5523C43.5109 45.5937 41.8224 45.5937 40.7811 44.5523L34.6667 38.4379V56C34.6667 57.4727 33.4728 58.6666 32 58.6666C30.5272 58.6666 29.3333 57.4727 29.3333 56V38.4379Z"
      fill="#9CA3AF"
    />
  </svg>
);
